
import { useEffect } from "react";
import NavBar from "@/components/NavBar";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import InsuranceCarousel from "@/components/InsuranceCarousel";
import About from "@/components/About";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import CompanyCarousel from "@/components/CompanyCarousel";
import AgentProfile from "@/components/AgentProfile";
import { useUserLocation } from "@/hooks/use-user-location";

const Index = () => {
  const { stateName, isLoading } = useUserLocation();
  
  // Add class to prevent FOUC (Flash of Unstyled Content)
  useEffect(() => {
    document.documentElement.classList.add('js-loaded');
    
    return () => {
      document.documentElement.classList.remove('js-loaded');
    };
  }, []);

  return (
    <div className="min-h-screen w-full overflow-x-hidden">
      <NavBar />
      <main className="w-full">
        <Hero />
        <section className="py-16 bg-white w-full">
          <div className="container mx-auto px-6 max-w-4xl">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-[#0c4a6e]">
              La cobertura dura hasta finales de 2026!
            </h2>
            <p className="text-lg md:text-xl text-center mb-12 text-gray-700">
              Algunos de los principales operadores y corredores con los que trabajamos en {isLoading ? "Florida" : stateName || "Florida"} incluyen:
            </p>
            <CompanyCarousel />
          </div>
        </section>
        <Features />
        <InsuranceCarousel />
        <AgentProfile />
        <About />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
